import { Alert } from "antd";
import moment from "moment-jalaali";

function ConsultationMessage({ statuses }) {

  return (
    <>
      {statuses.map((status) => {

        if (
          (status?.product?.name && !status?.reserve) ||
          !Object.keys(status?.reserve)
        )
          return (
            <div>
              <Alert
                message="مشاوره در صف بررسی قرار گرفت"
                description={`درخواست شما برای ${status?.product?.name} در صف بررسی مدیریت قرار گرفت و به محض تنظیم قرار ملاقات، از همین پنل قابل مشاهده میباشد.`}
                type="info"
                banner
                style={{ width: "100%", marginBottom: "30px" }}
              />
            </div>
          );

        if (
          status?.product?.name &&
          Object.keys(status.reserve).length &&
          moment(status?.reserve?.endAt).isSameOrAfter(Date.now())
        )
          return (
            <div>
              <Alert
                message={
                  <p style={{padding:0, margin:0}}>
                    قرار ملاقات شما مربوط به{" "}
                    <strong>{status.product.name}</strong> در تاریخ{" "}
                    <strong>
                      {moment(status.reserve.startAt).format("jYYYY/jMM/jDD")}
                    </strong>{" "}
                    از ساعت{" "}
                    <strong>
                      {moment(status.reserve.startAt).format("HH:mm")}
                    </strong>{" "}
                    تا{" "}
                    <strong>
                      {moment(status.reserve.endAt).format("HH:mm")}
                    </strong>{" "}
                    در مکان <strong>{status.reserve.product.name}</strong> تنظیم
                    شده است.
                  </p>
                }
                type="success"
                banner
                style={{ width: "100%", marginBottom: "30px" }}
              />
            </div>
          );
      })}
    </>
  );
}

export default ConsultationMessage;
